/**
 * Cart drawer upsell ATC — classic script (no ES modules).
 * Uses document click delegation so it works after cart morphs.
 */
(function () {
  if (window.__brightsideCartUpsellBound) return;
  window.__brightsideCartUpsellBound = true;

  var DISMISS_PREFIX = 'cart-upsell-dismissed-';
  var loading = false;

  function cartAddUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  }

  function cartUpdateUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url) || '/cart/update.js';
  }

  function dismissKey(root) {
    var productId = root && root.getAttribute('data-product-id');
    var variantId = root && root.getAttribute('data-variant-id');
    return DISMISS_PREFIX + (productId || variantId || 'default');
  }

  function isDismissed(root) {
    try {
      return sessionStorage.getItem(dismissKey(root)) === '1';
    } catch (e) {
      return false;
    }
  }

  function hideIfDismissed(root) {
    if (!root || !isDismissed(root)) return;
    root.hidden = true;
    root.setAttribute('hidden', '');
  }

  function scanDismissed() {
    document.querySelectorAll('cart-drawer-upsell').forEach(hideIfDismissed);
  }

  function sectionIds() {
    return Array.prototype.slice
      .call(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (el) {
        return el.getAttribute('data-section-id');
      })
      .filter(Boolean);
  }

  function dispatchCartUpdate(resource, root, sections, itemCount, variantId) {
    var productId = (root && root.getAttribute('data-product-id')) || variantId;
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: resource,
          sourceId: productId,
          data: {
            source: 'cart-drawer-upsell',
            itemCount: itemCount,
            productId: productId,
            variantId: variantId,
            sections: sections || {},
          },
        },
      })
    );
  }

  async function addUpsell(root, button) {
    if (!root || loading) return;

    var variantId = root.getAttribute('data-variant-id');
    if (!variantId) {
      console.error('[cart-upsell] missing data-variant-id');
      return;
    }

    var discountPercent = root.getAttribute('data-discount-percent') || '50';
    var badgeText = root.getAttribute('data-badge-text') || discountPercent + '% off';
    var discountCode = (root.getAttribute('data-discount-code') || '').trim();
    var label = root.querySelector('[data-cart-upsell-label]');
    var spinner = root.querySelector('[data-cart-upsell-spinner]');
    var ids = sectionIds();

    loading = true;
    root.setAttribute('data-loading', 'true');
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('disabled', 'disabled');
    }
    if (spinner) spinner.classList.remove('hidden');

    try {
      var formData = new FormData();
      formData.set('id', String(variantId));
      formData.set('quantity', '1');
      formData.set('properties[_cart_upsell]', String(discountPercent));
      formData.set('properties[_cart_upsell_badge]', badgeText);
      if (ids.length) {
        formData.set('sections', ids.join(','));
        formData.set('sections_url', window.location.pathname);
      }

      var addResponse = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Brightside-Cart-Upsell': '1',
        },
        body: formData,
      });

      var addResult = await addResponse.json();
      if (addResult.status && addResult.message) {
        throw new Error(addResult.description || addResult.message);
      }

      var sections = addResult.sections || {};
      var itemCount = Number(addResult.quantity) || 1;

      if (discountCode) {
        var updateResponse = await fetch(cartUpdateUrl(), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            discount: discountCode,
            sections: ids.join(','),
            sections_url: window.location.pathname,
          }),
        });
        var updateResult = await updateResponse.json();
        if (updateResult.sections) sections = updateResult.sections;
        if (typeof updateResult.item_count === 'number') itemCount = updateResult.item_count;
      } else {
        try {
          var cartResponse = await fetch('/cart.js');
          var cart = await cartResponse.json();
          if (typeof cart.item_count === 'number') itemCount = cart.item_count;
        } catch (e) {
          /* ignore */
        }
      }

      dispatchCartUpdate(addResult, root, sections, itemCount, variantId);
    } catch (error) {
      console.error('[cart-upsell] add failed:', error);
      if (label) {
        var previous = label.textContent;
        label.textContent = 'Unable to add';
        setTimeout(function () {
          if (previous) label.textContent = previous;
        }, 2000);
      }
    } finally {
      loading = false;
      root.setAttribute('data-loading', 'false');
      if (button) {
        button.removeAttribute('aria-busy');
        button.removeAttribute('disabled');
      }
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function onDismiss(root) {
    try {
      sessionStorage.setItem(dismissKey(root), '1');
    } catch (e) {
      /* ignore */
    }
    if (root) {
      root.hidden = true;
      root.setAttribute('hidden', '');
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var addButton = target.closest('[data-cart-upsell-add]');
      if (addButton) {
        var addRoot = addButton.closest('cart-drawer-upsell');
        if (!addRoot) return;
        event.preventDefault();
        event.stopPropagation();
        addUpsell(addRoot, addButton);
        return;
      }

      var dismissButton = target.closest('[data-cart-upsell-dismiss]');
      if (dismissButton) {
        var dismissRoot = dismissButton.closest('cart-drawer-upsell');
        if (!dismissRoot) return;
        event.preventDefault();
        event.stopPropagation();
        onDismiss(dismissRoot);
      }
    },
    true
  );

  // Expose for optional inline onclick fallback
  window.__brightsideCartUpsellAdd = function (button) {
    var root = button && button.closest ? button.closest('cart-drawer-upsell') : null;
    return addUpsell(root, button);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanDismissed);
  } else {
    scanDismissed();
  }

  document.addEventListener('cart:update', function () {
    setTimeout(scanDismissed, 50);
  });
})();
